import React, { useContext, useEffect, useRef, useState } from 'react'

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from 'primereact/confirmdialog'; // To use confirmDialog method

// ------------------ COMPONENTES DE BASE--------------------------
import Card from '../../../../../Base/Components/Card/Card'
import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../../../Base/Context/AuthContext/AuthContext';
import { setTitlePage } from '../../../../../Base/Services/Config/ConfigService';
import { toastShow } from '../../../../../Base/Services/ToastService';
import { getLabel } from '../../../../../Base/Services/Language/LanguageService';
import { baseLang } from '../../../../../Base/Lang/BaseLang';
import { ConfigContext } from '../../../../../Base/Context/ConfigContext/ConfigContext';
import { EnviarCorreoAsignacionR } from '../../../../../Base/Services/Email/EnviarCorreo';

// ------------------- CONSULTAS A LA API---------------------------
import { getLiberarRequisa } from '../../../../../API/Compras/Requisas/LiberarRequisa/LiberarRequisaRequest';
import { getEstadosCategory } from '../../../../../API/Global/Status/StatusRequests';
import {  ChangeAuth1, getAutorizaciones } from '../../../../../API/Compras/Autorizaciones/AutorizacionesRequest';
import { getDetalleRequisaID, getEncabezadoRequisaID } from '../../../../../API/Compras/RequisiscionCompras/PurchaseRequestDetails';

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import CrudRequisa from '../CrudRequisa/CrudRequisa';
import { useLocation } from 'react-router-dom';

const LiberarRequisaScreen = () => {

    const { userAuth } = useContext(AuthContext);
    const { config } = useContext(ConfigContext);
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [requisaEdit, setRequisaEdit] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [data, setData] = useState([]);
    const [showModalPermiso, setShowModalPermiso] = useState(false);
    const [password, setPassword] = useState('');
    const [estadoss, setEstados] = useState(false);
    const [Autorizaciones, setAutorizaciones] = useState([]);
    const [habilitar, setHabilitar] = useState(true);
    const [loadingCorreo, setLoadingCorreo] = useState(false);
    const location = useLocation();
    const idRequisaNotificacion = location.state?.Referencia;


  
    // ACA SOLO VA ESTE ACCESO
    // ACCESO DE LIBERAR REQUISA COMPRAS - GERENTE AREA
    const [hiddenliberarRequisa, setHiddenLiberarRequisa] = useState(
        userAuth.AccessWeb.split(",")
            .map((e) => parseInt(e))
            .includes(27)
    );

    // ACCESO APROBAR REQUISA FINANZAS
    const [hiddenAprobarRequisaFinanzas, setHiddenAprobarRequisaFinanzas] = useState(
        userAuth.AccessWeb.split(",")
            .map((e) => parseInt(e))
            .includes(30)
    );

    // ACCESO APROBAR REQUISA GERENTE PLANTA
    const [hiddenAprobarRequisaGerentePlanta, setHiddenAprobarRequisaGerentePlanta] = useState(
        userAuth.AccessWeb.split(",")
            .map((e) => parseInt(e))
            .includes(32)
    );

    const getInfo = async () => {
        setLoading(true);
        const t = await getLiberarRequisa();
        setData(t);
        const esta = getEstadosCategory('PurchaseRequests');
        setEstados(esta)
        setLoading(false);
        const autorizacionesData = await getAutorizaciones();
        setAutorizaciones(autorizacionesData.filter((autorizacion) => autorizacion.IdTipo === 8));
    }

    // CAMBIAR FIRMAS DE REVISION BODEGA Y 
    const handleCheckboxChange = async (event, data, IdPermisoGeneral, NombrePermiso) => {
        const dataToSend = data.map((item) => {
            return {
                    IdPurcharesRequestDetail: item?.IdPurcharesRequestDetail,
                    IdPermisoGeneral: IdPermisoGeneral,
                    Autorizo: !item[NombrePermiso],
                    IdUsuarioAutorizo: userAuth?.IdUser
                }
        });
        confirmDialog({
            message: `¿Está seguro que desea liberar ${data.length} ${data.length > 1 ? 'permisos' : 'permiso'}?`,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: async() => {
                const respuestaDetalles = await ChangeAuth1(dataToSend);
                if (respuestaDetalles[0]?.ESTADO === 1) {
                    toastShow(
                        toast,
                        "success",
                        "Guardado",
                        respuestaDetalles[0].MENSAGE
                    );
                    getInfo()
                    enviarCorreoAgente(respuestaDetalles)
                    
                } else {
                    toastShow(
                        toast,
                        "error",
                        "Error",
                        respuestaDetalles[0].MENSAGE
                    );
                }
            },
            reject: () => {}
        });
        setSelected([]);
    };

    const enviarCorreoAgente = async (respuestaDetalles) => {
        if (respuestaDetalles[0]?.ESTADO === 1) {
            for (const detalle of respuestaDetalles) {
                const IdPurchaseRequest = detalle?.IdPurcharesRequest;
                if (detalle.IdStatus === 14) {
                    const encabezado = await getEncabezadoRequisaID(IdPurchaseRequest);
                    const detalles = await getDetalleRequisaID(IdPurchaseRequest);
                    enviarAsignacion(null, encabezado[0], detalles)
                }
            }
        }
    };


    const enviarAsignacion = async (mostrarToast = null, encabezado, detalles) => {
        const emailAgente = detalles[0]?.EmailAgente;
        const emailEdit = detalles[0]?.EmailEdit;
        const emailSolicita = detalles[0]?.EmailSolicita;

        EnviarCorreoAsignacionR({
            setLoadingCorreo,
            toast,
            showToas: true,
            to: [emailAgente, emailSolicita].join(", "),
            bcc: emailEdit,
            subject: `Asignación de Requisición No. ${encabezado?.PurchaseRequest} / ${encabezado?.Area}`,
            encabezado: encabezado,
            detalles: detalles,
            mostrarToast: mostrarToast
        });

    };
    
    const columns = [
        {
            field: 'IdPurcharesRequestDetail',
            header: 'ID',
            headerEn: 'ID',
            className: "Xsmall",
            hidden: userAuth.IdRol === 1,
            frozen: true,
        },
        {
            field: 'DateCreated',
            header: 'Fecha',
            headerEn: 'Date',
            className: "medium",
            Format: 'DateTime',
            frozen: true,
        },
        {
            field: 'StatusName',
            header: 'Estado',
            headerEn: 'Status',
            className: "medium",
            body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
            Format: 'Estado',
            frozen: true,
        },
        {
            field: 'PurchaseRequest',
            header: 'No. Requisa',
            headerEn: 'No. Requisition',
            className: "small",
            Format: 'Modal',
            Sumary: 'count',
            frozen: true,
            filter: false,
            initialFilterModel: true
        },

        {
            field: 'CodigoProducto',
            header: 'Codigo Producto',
            headerEn: 'Product Code',
            className: "Xsmall",
        },
        {
            field: 'NombreProducto',
            header: 'Producto',
            headerEn: 'Product',
            className: "Xlarge",
        },
        {
            field: 'Description',
            header: 'Descripción',
            headerEn: 'Description',
            className: "Xlarge",
        },
        {
            field: 'Inventario',
            className: "Xsmall",
            header: 'Inventario',
            headerEn: 'Inventary',
            Format: 'Currency'
        },
        {
            field: 'Quantity',
            className: "Xsmall",
            header: 'Solicitado',
            headerEn: 'Quantity',
            Format: 'Currency'
        },
        {
            field: 'Area',
            header: 'Area',
            className: "medium",
        },
        {
            field: 'NombreCategoria',
            header: 'Tipo Producto',
            headerEn: 'Product Type',
            className: "small ",
        },
        {
            field: 'UnitName',
            header: 'Unidad',
            headerEn: 'Unit',
            className: "Xsmall",
        },
        {
            field: 'Comment',
            header: 'Comentario',
            headerEn: 'Comment',
            className: "Xlarge",
        },
        {
            field: 'UserName',
            header: 'Solicita',
            headerEn: 'Request',
            className: "medium",
        },

        ...Autorizaciones.map((autorizacion) => {
            return {
                field: autorizacion?.NombrePermiso,
                header: autorizacion.NombrePermiso,
                frozen: true,
                alignFrozen: "right",
                align: "center",
                className: "Xsmall",
                Format: "Checkbox",
                filter: false,
                hidden: hiddenliberarRequisa,
                onChange: (event, {data}) => {
                    if (autorizacion?.IdPermisoGeneral === 3) {
                        if (selected.length === 0) {
                            handleCheckboxChange(
                                event,
                                [data],
                                autorizacion?.IdPermisoGeneral,
                                autorizacion.NombrePermiso
                            );
                        } else {
                            handleCheckboxChange(
                                event,
                                selected,
                                autorizacion?.IdPermisoGeneral,
                                autorizacion.NombrePermiso
                            );
                        }
                    }
                },
            }
        }),
    ];

    const table = {
        Columns: columns,
        Data: data,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
        showModal: e => showModal(e),
        initialFilterModel: idRequisaNotificacion
            ? {
                PurchaseRequest: {
                    type: 'equals',
                    filter: idRequisaNotificacion,
                },
            }
            : null,
    };

    

    const showModal = (purchaseRequest) => {
        setRequisaEdit(purchaseRequest);
        setShowDialog(true);
    }

    const onHide = () => {
        setShowDialog(false);
        setShowModalPermiso(false);
        setRequisaEdit(null);
        setSelected([]);
        setPassword('');
    }

    const cerrarConfirmacion = () => {
        // Mostrar confirmación si hay ediciones sin guardar
        if (habilitar && requisaEdit !== null) {
          confirmDialog({
            message: "¿Estás seguro de cerrar sin guardar los cambios?",
            header: "Cerrar sin guardar",
            icon: "pi pi-exclamation-triangle",
            acceptLabel: "Sí",
            accept: () => {
            onHide() // Cerrar el diálogo
            },
            rejectLabel: "No",
            reject: () => {}, // No hacer nada si el usuario cancela
            style: { backgroundColor: "white" },
          });
        } else {
            onHide()
        }
      };


    useEffect(() => {
        setTitlePage(getLabel(baseLang, "liberarRequisas", config.language));
        getInfo();
    }, [])


    return (
        <div>
            <Toast ref={toast} />
            <Card
                titulo={<div className='botones'>
                    <h2>{getLabel(baseLang, "liberarRequisas", config.language)}</h2>
                    <Button icon='pi pi-search' tooltip='Buscar' onClick={getInfo} />
                </div>}

                contenido={<div className='pt-4' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />
            <Dialog visible={showDialog}
              onHide={() => {cerrarConfirmacion()}}
              maximizable
              closeOnEscape={false}
              maximized={true} >
                <CrudRequisa 
                idRequisa={requisaEdit} 
                setRequisaToShow={setRequisaEdit}
                showDialog={showDialog} 
                actualizarRequisasScreen={getInfo}
                habilitar={habilitar}
                setHabilitar={setHabilitar} />
            </Dialog>
        </div>
    )
}

export default LiberarRequisaScreen